import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {affiliateRevenueReport_template} from "../components/templates/affiliateRevenueReport_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

declare var ko: any;
declare var page: any;

export class affiliateRevenueReport extends vnModule_knockoutJS{

    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected XHRHdl: XMLHttpRequestHandler;
    protected affiliateRevenueReport_template: affiliateRevenueReport_template;

    protected getModuleName(){
        return "affiliateRevenueReport";
    }

    buildContent() : Array<Element>{

        this.affiliateRevenueReport_template = new affiliateRevenueReport_template( "affiliateRevenueReport", this.viewModel, this );
        this.template = this.affiliateRevenueReport_template;

        return [this.affiliateRevenueReport_template.build()];
    }

    public fillPage() : void{

        this.affiliateRevenueReport_template.buildDatePickerCalendar();

        // First get the presets
        this.getSearchPresetsListData();
    }

    public getListFormData(): void{

        let usrReq_url: string = '/api/affiliateRevenueReport/list_form_data';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();

    }

    protected onFilterRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.affiliateRevenueReport_template.validationsList.clearMessages();
                obj.updateFilters(responseParsed);
                obj.updateViewModelFromPath();
                obj.getListData();
            });

            if(req.request.readyState == 4){

                // LOADING : ends
                obj.loadingOut(obj.affiliateRevenueReport_template.builtTemplate);
            }
        };
    }

    public getListData(): void{

        this.loadingIn(this.affiliateRevenueReport_template.builtTemplate.children.namedItem("list-results"));

        //this.affiliateRevenueReport_template.validateOrderBy();

        let subViewModel = this.affiliateRevenueReport_template.getViewModelForRequest();
        let baseApiUrl = '/api/affiliateRevenueReport/list_data';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getListData');
    }

    protected onDataRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.affiliateRevenueReport_template.resetSelectedRows();
                obj.affiliateRevenueReport_template.validationsList.clearMessages();
                obj.updateList(responseParsed);
            });

            if(req.request.readyState == 4 && req.request.status != 0){

                // LOADING : ends
                obj.loadingOut(obj.affiliateRevenueReport_template.builtTemplate.children.namedItem("list-results"));
            }
        };
    }

    protected updateFilters(responseParsed: any){

        this.affiliateRevenueReport_template.setBrandFilterItems(responseParsed.departments);
        this.affiliateRevenueReport_template.setAffiliateFilterItems(responseParsed.affiliates);
        this.affiliateRevenueReport_template.setViewModesItems();
        this.affiliateRevenueReport_template.setRevenueOptionsItems();
    }

    protected updateList(responseParsed: any) {

        this.affiliateRevenueReport_template.setHeader(responseParsed.headers);
        this.affiliateRevenueReport_template.setTableData(responseParsed.tableData);

    }

    protected filterMultipleSelectorOnChange(){

        this.getListData();
    }

    protected filterDateOnChange(){
        this.getListData();
    }

    protected filterSimpleOnChange(){
        this.getListData();
    }

    public listReorder(){
        this.getListData();
    }
}



// WEBPACK FOOTER //
// ./js/modules/affiliateRevenueReport.ts